// extracted by mini-css-extract-plugin
export var bubble = "_1i-0";
export var container = "_1i-f";
export var contrastBorder = "_1i-g";
export var greyOut = "_1i-2";
export var initialsColor0 = "_1i-3";
export var initialsColor1 = "_1i-4";
export var initialsColor10 = "_1i-d";
export var initialsColor11 = "_1i-e";
export var initialsColor2 = "_1i-5";
export var initialsColor3 = "_1i-6";
export var initialsColor4 = "_1i-7";
export var initialsColor5 = "_1i-8";
export var initialsColor6 = "_1i-9";
export var initialsColor7 = "_1i-a";
export var initialsColor8 = "_1i-b";
export var initialsColor9 = "_1i-c";
export var initialsWrapper = "_1i-1";
export var large = "_1i-l";
export var medium = "_1i-k";
export var mediumSmall = "_1i-j";
export var mediumSmallMedium = "_1i-o";
export var micro = "_1i-h";
export var small = "_1i-i";
export var tiny = "_1i-n";
export var xTiny = "_1i-m";